"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreamMetadata = void 0;
const DecodingUtils_1 = require("../../decoder/DecodingUtils");
const PhysicalStreamType_1 = require("./PhysicalStreamType");
const LogicalStreamType_1 = require("./LogicalStreamType");
const LogicalLevelTechnique_1 = require("./LogicalLevelTechnique");
const PhysicalLevelTechnique_1 = require("./PhysicalLevelTechnique");
const DictionaryType_1 = require("./DictionaryType");
const OffsetType_1 = require("./OffsetType");
const LengthType_1 = require("./LengthType");
class StreamMetadata {
    constructor(physical_stream_type, logical_stream_type, logical_level_technique1, logical_level_technique2, physical_level_technique, num_values, byte_length) {
        this.physical_stream_type = physical_stream_type;
        this.logical_stream_type = logical_stream_type;
        this.logical_level_technique1 = logical_level_technique1;
        this.logical_level_technique2 = logical_level_technique2;
        this.physical_level_technique = physical_level_technique;
        this.num_values = num_values;
        this.byte_length = byte_length;
    }
    static decode(tile, offset) {
        const stream_type = tile[offset.get()];
        const physical_stream_type = Object.values(PhysicalStreamType_1.PhysicalStreamType)[stream_type >> 4];
        let logical_stream_type = null;
        switch (physical_stream_type) {
            case PhysicalStreamType_1.PhysicalStreamType.DATA:
                logical_stream_type = new LogicalStreamType_1.LogicalStreamType(Object.values(DictionaryType_1.DictionaryType)[stream_type & 0xf]);
                break;
            case PhysicalStreamType_1.PhysicalStreamType.OFFSET:
                logical_stream_type = new LogicalStreamType_1.LogicalStreamType(null, Object.values(OffsetType_1.OffsetType)[stream_type & 0xf]);
                break;
            case PhysicalStreamType_1.PhysicalStreamType.LENGTH:
                logical_stream_type = new LogicalStreamType_1.LogicalStreamType(null, null, Object.values(LengthType_1.LengthType)[stream_type & 0xf]);
                break;
        }
        offset.increment();
        const encodings_header = tile[offset.get()] & 0xFF;
        const logical_level_technique1 = Object.values(LogicalLevelTechnique_1.LogicalLevelTechnique)[encodings_header >> 5];
        const logical_level_technique2 = Object.values(LogicalLevelTechnique_1.LogicalLevelTechnique)[encodings_header >> 2 & 0x7];
        const physical_level_technique = Object.values(PhysicalLevelTechnique_1.PhysicalLevelTechnique)[encodings_header & 0x3];
        offset.increment();
        const size_info = DecodingUtils_1.DecodingUtils.decodeVarint(tile, offset, 2);
        const num_values = size_info[0];
        const byte_length = size_info[1];
        return new StreamMetadata(physical_stream_type, logical_stream_type, logical_level_technique1, logical_level_technique2, physical_level_technique, num_values, byte_length);
    }
    physicalStreamType() {
        return this.physical_stream_type;
    }
    logicalStreamType() {
        return this.logical_stream_type;
    }
    logicalLevelTechnique1() {
        return this.logical_level_technique1;
    }
    logicalLevelTechnique2() {
        return this.logical_level_technique2;
    }
    physicalLevelTechnique() {
        return this.physical_level_technique;
    }
    numValues() {
        return this.num_values;
    }
    byteLength() {
        return this.byte_length;
    }
}
exports.StreamMetadata = StreamMetadata;
//# sourceMappingURL=StreamMetadata.js.map